import { IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDocumentViewer } from "../documentViewer/useDocumentViewer";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { faRulerTriangle } from "@fortawesome/pro-solid-svg-icons";

export const MeasureAndRedactAction = ({ attachmentId, editable }: { attachmentId: number; editable: boolean }) => {
    const { showAttachments } = useDocumentViewer(editable);

    return (
        <Tooltip title={"Measure"}>
            <IconButton onClick={onIconClicked}>
                <FontAwesomeIcon icon={faRulerTriangle} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );

    function onIconClicked(): void {
        showAttachments([attachmentId]);
    }
};
